import React from "react";
import { Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import OurSloutions from "../../Components/OurSloutions/OurSloutions";
import StudyCases from "../../Components/StudyCases/StudyCases";
import ProjectCost from "../../Components/ProjectCost/ProjectCost";
import TheyTrustUS from "../../Components/TheyTrustUs/TheyTrustus";
import MeetTalk from "../../Components/Meet&Talk/Meet&Talk";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

const IndustryPage = () => {
  const navigate = useNavigate();
  const BackToHome = () => {
    navigate("/");
  };

  return (
    <div>
      <Box
        sx={{
          position: "fixed",
          top: "150px",
          left: "30px",
          zIndex: 9999,
          width: "63px",
          height: "63px",
          borderRadius: "100px",
          backgroundColor: "#49A995",
          color: "#FFF",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "#025b62ff",
          },
        }}
      >
        <Button onClick={BackToHome}>
          <ArrowBackIosNewRoundedIcon style={{ color: "#FFF" }} />
        </Button>
      </Box>

      <OurSloutions />
      <StudyCases />
      <ProjectCost />
      <TheyTrustUS />
      <MeetTalk />
    </div>
  );
};

export default IndustryPage;
